import type { DocumentEntryView } from '@UI/Store/Documents/Views/buildDocumentEntryView';

/**
 * Immutable View: `readonly` properties, frozen at the end of the constructor.
 * One row of a list node: its own field/group/list entries — same recursive shape as a section, but
 * with no `key`/`title` of its own (the owning `DocumentListEntryView` carries those). `position` is
 * the row's 1-indexed rank within its own list, set once by `buildDocumentEntryView` — a stable data
 * identity for React keys and copy, rather than the array index the renderer would otherwise read.
 */
class DocumentListItemView {
	readonly entries: readonly DocumentEntryView[];
	readonly position: number;

	constructor(entries: readonly DocumentEntryView[], position: number) {
		this.entries = entries;
		this.position = position;

		Object.freeze(this);
	}

	/** The 0-indexed rank the item routes expect: the only place `position` is converted. */
	get index(): number {
		return this.position - 1;
	}
}

export default DocumentListItemView;
